import React, { useRef, useState, useEffect } from "react";
import { CgClose } from "react-icons/cg";
import Slider from "react-slick";
import StarRatings from "react-star-ratings";
import useDeviceSize from "./useDeviceSize";
import { sanitizeHTML } from "../Utils";

function ReviewImagesModal(props) {
  const { selectedReviewMedia, selectedIndex, review, closeModal } = props;
  const [activeIndex, setActiveIndex] = useState(selectedIndex);
  const [activeMedia, setActiveMedia] = useState(selectedReviewMedia);
  const [width] = useDeviceSize();
  const slider1 = useRef(null);

  const settings = {
    dots: false,
    infinite: false,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    ref: slider1,
    fade: width > 768 ? true : false,
    cssEase: width > 768 ? "linear" : "",
    currentSlide: activeIndex,
    prevArrow: <></>, // or null
    nextArrow: <></>, // or null
  };

  function changeMedia(mediaSrc, index) {
    setActiveIndex(index);
    setActiveMedia(mediaSrc);
    slider1.current.slickGoTo(index);
  }



  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft" && activeIndex > 0) {
        setActiveIndex((prev) => prev - 1);
        slider1.current.slickGoTo(activeIndex - 1);
      }
      if (event.key === "ArrowRight" && activeIndex < review.images.length - 1) {
        setActiveIndex((prev) => prev + 1);
        slider1.current.slickGoTo(activeIndex + 1);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [activeIndex, review.images.length]);

  return (
    <div
    className={`fixed inset-0 w-full h-full z-30 overflow-scroll`}
    style={{
      backgroundColor: width > 1024 ? "rgba(0, 0, 0, 0.4)" : "black", // Dark background with transparency for small screens
    }} >
    <div className="relative w-full h-full">
      <div
        className={`absolute top-0 left-0 right-0 bottom-0 m-auto z-40 w-full ${width > 1024 ? 'max-w-[1057px]' : 'max-w-full'} ${width > 1024 ? 'h-[70vh]' : 'h-full'} p-5 box-border rounded-lg ${width > 1024 ? 'bg-white' : 'bg-black'}`}
      >
        <CgClose
          className={`absolute top-4 right-6 p-2 w-9 h-9 z-10 cursor-pointer ${width > 1024 ? 'text-black' : 'text-[#f5a523]'}`}
          onClick={closeModal}
        />
        <div
          className={`text-white text-center font-bold p-4 ${width > 1024 ? 'hidden' : 'block'}`}
        >
          {activeIndex + 1} / {review?.media.length}
        </div>
        <div
          className={`flex ${width > 1024 ? 'flex-row' : 'flex-col'} w-full h-full justify-center`}
        >
          <div
            className={`flex ${width > 1024 ? 'w-3/5 mb-0' : 'w-full mb-5'} items-start justify-center`}
          >
            <Slider
              {...settings}
              className={`${width > 1024 ? 'w-full h-1/2' : 'w-[86%] h-[86%]'}`}
              afterChange={(index) => setActiveIndex(index)}
            >
              {review.media.map((media, i) => (
                <div key={i} className="flex">
                  {media.type === "image" ? (
                    <img
                      src={media?.url}
                      alt="review image"
                      className={`${width > 1024 ? 'w-[502px] h-[605px]' : 'w-[370px] h-[500px]'} max-h-[65vh] rounded-lg object-cover`}
                      loading="lazy"
                    />
                  ) : (
                      <video
                      src={media?.url}
                      alt="review image"
                      className={`${width > 1024 ? 'w-[502px] h-[605px]' : 'w-[370px] h-[500px]'} max-h-[65vh] rounded-lg object-cover`}
                      loading="lazy"
                      controls
                    />
                  )}
                </div>
              ))}
            </Slider>
          </div>
          <div
            className={`w-full ${width > 1024 ? 'translate-x-[-15%]' : ''} pr-normal ${width > 1024 ? 'text-black' : 'text-white'}`}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <div className="text-sm lg:text-2xl mt-1">{review.name}</div>
                <StarRatings
                  starDimension="17px"
                  starEmptyColor="#e3e3e3"
                  starRatedColor="#f5a523"
                  starSpacing="1px"
                  rating={parseInt(review.rating)}
                />
              </div>
              <div className="lg:text-lg text-sm text-gray-400 mr-4">
                {review?.date_added.replace("-", " ").replace("-", " ")}
              </div>
            </div>
            <div
              className="lg:text-lg  text-sm mt-4 ml-2 text-black"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(review?.text) }}
            ></div>
            <div
              className={`mt-5 mb-4 font-bold text-lg ${width > 1024 ? 'block' : 'hidden'}`}
            style={{transform:width>1024?"translateY(295px)":""}}>
              Media in this review
            </div>
            <div
              className={`grid ${width > 1024 ? 'grid-cols-5' : 'hidden'} gap-2`}
              style={{transform:width>1024?"translateY(290px)":""}} >
              {review.media.map((media, i) => (
                <div >
                  {media?.type === "image" ? (
                    <div>
                      <img
                        key={i}
                        src={media.url}
                        alt={`Review Image ${i + 1}`}
                        width={65}
                        height={96}
                        className={`rounded-lg cursor-pointer max-h-[90px] ${activeIndex === i ? 'border-2 border-[#1E3D58]' : ''}`}
                        tabIndex={0}
                        onClick={() => {
                          changeMedia(media, i);
                        }}
                        loading="lazy"
                      />
                    </div>
                  ) : (
                    <div>
                      <video
                        key={i}
                        src={media.url}
                        alt={`Review Video ${i + 1}`}
                        width={65}
                        height={96}
                        className={`rounded-lg cursor-pointer max-h-[90px] ${activeIndex === i ? 'border-2 border-[#1E3D58]' : ''}`}
                        tabIndex={0}
                        onClick={() => {
                          changeMedia(media, i);
                        }}
                        loading="lazy"
                      />
                    </div>
                  )}

                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  );
}

export default ReviewImagesModal;
